
import React from 'react';
import { Language } from '../../types';

interface DocsContentProps {
  language: Language;
  docsContent: any[];
  activeSection: string;
  onBack?: () => void;
}

const DocsContent: React.FC<DocsContentProps> = ({
  language,
  docsContent,
  activeSection,
  onBack
}) => {
  const isRtl = language === 'ar';

  return (
    <main className="flex-1 overflow-y-auto custom-scrollbar relative bg-slate-50 dark:bg-[#050507]">
       {/* Mobile Header */}
       <div className="lg:hidden p-4 border-b border-slate-200 dark:border-white/5 flex items-center gap-3 bg-white dark:bg-[#0a0a0c]">
          <button onClick={onBack} className="w-8 h-8 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-500"><i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i></button>
          <span className="font-black text-sm dark:text-white">{isRtl ? 'الوثائق' : 'Docs'}</span>
       </div>

       <div className="max-w-4xl mx-auto p-6 lg:p-12 pb-24">
          {docsContent.map(doc => (
             <div 
                key={doc.id} 
                id={doc.id}
                className={`
                   mb-12 scroll-mt-24 transition-opacity duration-500
                   ${activeSection === doc.id ? 'opacity-100 block' : 'hidden'}
                `}
             >
                <div className="flex items-center gap-4 mb-6 pb-6 border-b border-slate-200 dark:border-white/5">
                   <div className="w-12 h-12 rounded-2xl bg-emerald-500 flex items-center justify-center text-white text-xl shadow-lg shadow-emerald-500/20">
                      <i className={`fas ${doc.icon}`}></i>
                   </div>
                   <h1 className="text-2xl lg:text-3xl font-black text-slate-800 dark:text-white">
                      {isRtl ? doc.title.ar : doc.title.en}
                   </h1>
                </div>
                
                <div className="prose prose-slate dark:prose-invert max-w-none">
                   {isRtl ? doc.content.ar : doc.content.en}
                </div>
             </div>
          ))}
       </div>
    </main>
  );
};

export default DocsContent;
